import { useTranslate } from '@va/localization';
import { SectionHeader } from '@va/ui/components/white-label-customisation';
import { TabbedButton } from '@va/ui/design-system';
import { useEffect, useRef, useState } from 'react';
import { CustomSenderEmail } from './custom-sender/CustomSenderEmail';
import { useActiveSenderEmail } from './custom-sender/useActiveSenderEmail';
import { ReplyToEmailSection } from './ReplyToEmailSection';

enum TabsEnum {
  replyToEmailAddress = 0,
  customSenderEmail = 1,
}

const CustomEmailAddresses = () => {
  const activeSenderEmail = useActiveSenderEmail();

  const initialChange = useRef<boolean>(true);

  const getInitialSelectedTab = function (): TabsEnum {
    if (!activeSenderEmail) return TabsEnum.replyToEmailAddress;

    initialChange.current = false;
    return TabsEnum.customSenderEmail;
  };

  const [selectedTab, setSelectedTab] = useState(getInitialSelectedTab);

  useEffect(() => {
    if (!initialChange.current) return;
    if (!activeSenderEmail) return;

    initialChange.current = false;
    setSelectedTab(TabsEnum.customSenderEmail);
  }, [activeSenderEmail]);

  const translate = useTranslate();

  const tabButtons = [
    {
      label: translate('whiteLabel.email.tabs.replyTo'),
      value: TabsEnum.replyToEmailAddress,
      className: 'w-full! h-54! sm-initial:flex-1',
      tooltip: translate('whiteLabel.email.tabs.tooltips.replyTo'),
    },
    {
      label: translate('whiteLabel.email.tabs.customSenderEmail'),
      value: TabsEnum.customSenderEmail,
      className: 'w-full! h-54! sm-initial:flex-1',
      tooltip: translate('whiteLabel.email.tabs.tooltip.customSenderEmail'),
    },
  ];

  return (
    <div>
      <SectionHeader
        title={translate('whiteLabel.customEmail.title')}
        description={translate('whiteLabel.customEmail.info')}
      />
      <TabbedButton
        className='my-5 flex-col sm-initial:flex-row! h-auto!'
        buttonOptions={tabButtons}
        onChange={(value: TabsEnum) => {
          setSelectedTab(value);
        }}
        selectedValue={selectedTab}
      />

      {selectedTab === TabsEnum.customSenderEmail && <CustomSenderEmail />}
      {selectedTab === TabsEnum.replyToEmailAddress && <ReplyToEmailSection />}
    </div>
  );
};

export default CustomEmailAddresses;
